// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const WIKI_PLACE_IMAGE_IN_ARTICLE_WITH_FOLLOWING_CODE = "Pro vlo\u017een\u00ed obr\u00e1zku pou\u017eij tento k\u00f3d: ";
